export default "__VITE_ASSET__BmRlA051__"